import * as React from "react";
import { Component } from "react";
import { Field, Form, getFormValues, reduxForm } from "redux-form";
import styles from "../../../styles/forms/superadmin/add_boq_supply_types_wizard/AddBOQSupplyTypesForm.scss";
import Button from "../../../components/Button";
import Select from "../../../components/Select";
import Input from "../../../components/Input";
import { __, mapStateToProps, setTableParams, getLocalized } from "../../../core/utils";
import { withRouter } from "react-router";
import autobind from "autobind-decorator";
import ButtonGroup from "../../../components/ButtonGroup";
import { subscribe } from "react-contextual";
import Localization from "../../../helpers/Localization";

@subscribe(Localization, "localization")
@withRouter
@reduxForm({ form: "superadmin.add_boq_supply_types_wizard.add_boq_supply_types" })
@mapStateToProps(state => ({
    values: getFormValues("superadmin.add_boq_supply_types_wizard.add_boq_supply_types")(state),
    auth: state.auth,
    application_language_id: state.auth.language_id
}))
class AddBOQSupplyTypesForm extends Component {
    @autobind
    _handleSubmit(edit) {
        this.props.change('edit', edit);

        setTimeout(() => this.props.submit(), 10);
    }

    render() {
        const { localization, application_language_id } = this.props;

        const application_languages = _.transform(_.filter(this.props.localization.languages, language => language.application_language == true), (languages, language) => {
            languages[language.id] = language.id == this.props.auth.language_id;

            return languages;
        }, {});

        const boq_supply_type_groups = _.sortBy(_.map(localization.boq_supply_type_groups, item => ({
			value: item.id,
            priority: item.priority,
			label: getLocalized(item.name, application_language_id),
		})), 'priority');

          return (
            <Form onSubmit={this.props.handleSubmit} className={styles.wrapper}>
                <div className={styles.form}>
                    <Field name="name" localized={application_languages} component={Input} label="Name" />
				    <Field name="boq_supply_type_group_id" component={Select} searchable noSort options={boq_supply_type_groups} label="BOQ supply type group" />
                </div>
                <div className={styles.footer}>
                    <Button lightGray medium left middleText={__('button.cancel')} onClick={() => setTableParams('superadmin_boq_supply_types', {
                        add_boq_supply_types_wizard: undefined
                    })} />
                    <ButtonGroup>
                        <Button lightBlue medium middleText={__('button.create')} spinning={this.props.submitting} onClick={() => this._handleSubmit(false)} />
                        <Button lightBlue medium middleText={__('button.create-edit')} spinning={this.props.submitting} onClick={() => this._handleSubmit(true)} />
                    </ButtonGroup>
                </div>
            </Form>
        );
    }
}

export default AddBOQSupplyTypesForm;
